
<div class="card">
    <br>
    <div class="row" *ngIf="mensagemErro">
        <div class="col-sm-12">
          <div class="alert alert-danger" role="alert" *ngIf="mensagemErro">{{mensagemErro}}</div>
        </div>
      </div>

    <div class="row" style="padding: 15px 10px 10px 25px;">

      <div class="col-12 text-center"  style="padding-bottom:25px; padding-top:15px;">
        <h4><b>COMUNICADO LGPD</b></h4>
      </div>

      <div class="col-12 text-justify">
        Para participar da <b>Campanha Nota Premiada Bahia</b>, há obrigatoriedade de adesão ao <b>Termo de Consentimento para Tratamento de Dados Pessoais  (Lei de nº 13.709/2018-LGPD).</b>
        <br>
        <br>
        <b>Coordenação de Educação Fiscal/CEF/SGF/SEFAZ BAHIA</b>
        <br>
        <br>
        <b>Concorda em aderir ao Termo de Consentimento para Tratamento de Dados?</b>
        <br>
        <br>
      </div>
    </div>
    
    <div class="col-12 text-justify"> 
        <button style="margin-right: 6px"
                class="btn btn-bluelight" 
                data-toggle="tooltip" 
                title="Aceitar Termo LGPD"
                (click)="AceitarTermo()"
                [disabled]="bloqueioButtons">
            Sim
        </button>
        <button class="btn btn btn-danger"
                data-toggle="tooltip" 
                title="Não Aceitar Termo LGPD"
                [disabled]="bloqueioButtons"
                (click)="RecusarTermo()">
            Não
        </button>
     </div>
<br>
     <div class="col-sm-6">
        <a href="{{linkTermoLGPD}}" target="_blank" rel="noopener"><b>Ler Termos LGPD</b></a>
    </div>

  <br>
  <br>

</div>
  <!-- card -->
  


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-lgpd/consumidor-termo-lgpd.html